/**
 * assets/header.js
 * Drives the header's mobile menu toggle and search panel toggle, which
 * snippets/header.liquid renders but nothing previously wired up.
 */
(function () {
  const header = document.querySelector(".site-header");
  if (!header) return;

  function bindToggle(button, target, onOpen) {
    if (!button || !target) return;
    button.addEventListener("click", () => {
      const open = button.getAttribute("aria-expanded") !== "true";
      button.setAttribute("aria-expanded", String(open));
      target.hidden = false;
      if (target.id === "PredictiveSearch") target.hidden = !open;
      target.classList.toggle("open", open);
      if (open && onOpen) onOpen();
    });
  }

  const nav = document.getElementById("PrimaryNav");
  const search = document.getElementById("PredictiveSearch");
  bindToggle(header.querySelector(".nav-toggle"), nav);
  bindToggle(header.querySelector(".js-search-toggle"), search, () => {
    const input = search.querySelector('input[type="search"]');
    if (input) input.focus();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    header.querySelectorAll('[aria-expanded="true"]').forEach((btn) => btn.click());
  });
})();

/**
 * Predictive search: suggestions for products, recipes and pages as the
 * shopper types, from Shopify's /search/suggest.json endpoint.
 */
(function () {
  const input = document.querySelector("[data-ps-input]");
  const box = document.querySelector("[data-ps-results]");
  if (!input || !box) return;
  const settings = (window.driedYet && window.driedYet.settings) || {};
  const base = settings.searchUrl || "/search/suggest";
  let timer = null;
  let controller = null;

  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const money = (v) => (v == null || v === "" ? "" : "$" + Number(v).toFixed(2));

  function row(url, title, sub, img) {
    return `<a class="ps-row" role="option" href="${esc(url)}">` +
      (img ? `<img src="${esc(img)}" alt="" width="44" height="44" loading="lazy">` : `<span class="ps-noimg" aria-hidden="true"></span>`) +
      `<span class="ps-text"><span class="ps-title">${esc(title)}</span>${sub ? `<span class="ps-sub">${esc(sub)}</span>` : ""}</span></a>`;
  }

  async function run(q) {
    if (controller) controller.abort();
    if (q.length < 2) { box.hidden = true; box.innerHTML = ""; return; }
    controller = new AbortController();
    try {
      const url = `${base}.json?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=5&resources[options][unavailable_products]=hide`;
      const res = await fetch(url, { signal: controller.signal });
      const data = await res.json();
      const r = (data.resources && data.resources.results) || {};
      let html = "";
      if (r.products && r.products.length) {
        html += `<p class="ps-head">Products</p>` + r.products.map((p) => row(p.url, p.title, money(p.price), p.image)).join("");
      }
      if (r.articles && r.articles.length) {
        html += `<p class="ps-head">Recipes</p>` + r.articles.map((a) => row(a.url, a.title, "", a.image)).join("");
      }
      if (r.pages && r.pages.length) {
        html += `<p class="ps-head">Pages</p>` + r.pages.map((p) => row(p.url, p.title, "", null)).join("");
      }
      html += `<a class="ps-all" href="/search?q=${encodeURIComponent(q)}">See all results for “${esc(q)}”</a>`;
      if (!(r.products || []).length && !(r.articles || []).length && !(r.pages || []).length) {
        html = `<p class="ps-empty">No matches for “${esc(q)}”. Try “orange”, “margarita” or “smoked”.</p>`;
      }
      box.innerHTML = html;
      box.hidden = false;
    } catch (e) {
      if (e.name !== "AbortError") box.hidden = true;
    }
  }

  input.addEventListener("input", () => {
    clearTimeout(timer);
    timer = setTimeout(() => run(input.value.trim()), 200);
  });
  input.addEventListener("keydown", (e) => {
    if (e.key === "ArrowDown") {
      const first = box.querySelector("a");
      if (first) { e.preventDefault(); first.focus(); }
    }
  });
  box.addEventListener("keydown", (e) => {
    const links = Array.from(box.querySelectorAll("a"));
    const i = links.indexOf(document.activeElement);
    if (e.key === "ArrowDown" && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
    if (e.key === "ArrowUp") { e.preventDefault(); (i > 0 ? links[i - 1] : input).focus(); }
  });
})();
